import moment from 'moment';
import {
  BookingFormType,
  UpdateClosureObjectType,
} from '../../../redux/types/bookingTypes';
import styles from './ClosureBanner.module.scss';
import { getClosureReason } from '../../../utils/functions';
import { useDispatch } from 'react-redux';
import { setModalWindowData } from '../../../redux/reducers/pageSlice';
import { ModalWindowTypes } from '../../../utils/@globalTypes';

type BannerProps = {
  closure: UpdateClosureObjectType;
  cellWidth: number;
  type: 'start' | 'ending';
  currentDay: moment.Moment;
};
const ClosureBanner = ({
  closure,
  cellWidth,
  type,
  currentDay,
}: BannerProps) => {
  const diff =
    type === 'start'
      ? moment(closure.end_closure).diff(moment(closure.start_closure), 'days')
      : moment(closure.end_closure).diff(currentDay, 'days');

  const reason = closure.reason && getClosureReason(closure.reason);
  const dispatch = useDispatch();

  const handlerViewClosure = () => {
    dispatch(
      setModalWindowData({
        type: ModalWindowTypes.SHOW_OBJECT_CLOSURE,
        data: { closureItem: closure, type: BookingFormType.view },
      }),
    );
  };
  return (
    <div
      className={styles.container}
      style={{ width: cellWidth * diff - 2, left: cellWidth / 2 + 1 }}
      onClick={handlerViewClosure}
    >
      <div className={styles.title}>Объект закрыт</div>
      <div className={styles.reason}>{reason}</div>
    </div>
  );
};

export default ClosureBanner;
